import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed Redux hooks for use across the app.
 * Use these instead of useDispatch/useSelector for consistency
 * and future TypeScript migration support.
 */
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
